import { render } from "./EditShipment.vue?vue&type=template&id=4b32a6d2&scoped=true&ts=true"
import script from "./EditShipment.vue?vue&type=script&lang=ts"
export * from "./EditShipment.vue?vue&type=script&lang=ts"

import "./EditShipment.vue?vue&type=style&index=0&id=4b32a6d2&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b32a6d2"]])

export default __exports__